<template>
    <div class="w-100">
        <div class="map-item-filter">
            <div
                class="col-sm-12 nopads vehicle-list"
                :class="{ list_closed: !listOpen }"
            >
                <span
                    class="vehicle-list-title"
                    @click.stop="listOpen = !listOpen"
                >
                    {{ $t('menu.bridges') }}
                </span>
                <div
                    class="vehicle-list-caret"
                    :class="{ caret_open: listOpen }"
                    @click.stop="listOpen = !listOpen"
                >
                    <font-awesome-icon icon="caret-down" />
                </div>
                <div
                    v-if="listOpen"
                    class="col-sm-12 nopads vehicle-list-container"
                    style="overflow-x: hidden"
                >
                    <div class="d-flex flex-row mb-2 px-2">
                        <div class="col-6">
                            <div class="form-check d-flex align-items-center">
                                <input
                                    id="roads"
                                    v-model="onlyRoads"
                                    type="checkbox"
                                    class="form-check-input"
                                >
                                <label
                                    class="form-check-label px-2 pt-1"
                                    style="color: #ffffff; font-size: .9em"
                                    for="roads"
                                >
                                    {{ $t('bridge.only_roads') }}
                                </label>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-check d-flex align-items-center">
                                <input
                                    id="govt"
                                    v-model="onlyGovt"
                                    type="checkbox"
                                    class="form-check-input"
                                >
                                <label
                                    class="form-check-label px-2 pt-1"
                                    style="color: #ffffff; font-size: .9em"
                                    for="govt"
                                >
                                    {{ $t('bridge.only_govt') }}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <bridge-details v-if="item" :item="item" @close="item = null" @inspection="startInspection"/>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {timeUtils} from '../mixins/TimeUtils'
import {mapHelper} from '../mixins/MapMixin'
import {restApi} from '../mixins/RestApiMixin'
import {geometryMixin} from "../mixins/GeometryMixin.js";
import BridgeDetails from "./BridgeDetails.vue";

import bridgeSvg from '@/assets/bridge.svg'
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default {
    name: 'BridgeMap',
    components: {FontAwesomeIcon, BridgeDetails},
    mixins: [timeUtils, mapHelper, restApi, geometryMixin],
    props: {
        map: {
            type: Object,
            default: null
        },
        boundingBox: {
            type: Array,
            default: null
        },
        user: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            loading: false,
            item: null,
            bridges: [],
            listOpen: false,
            onlyRoads: false,
            onlyGovt: false,
            visibilityZoomLevel: 13,
            Z_INDEX: {
                BEHIND: 2,
                INFRONT: 4
            }
        }
    },

    watch: {
        map() {
            this.$nextTick(function () {
                this.fetchBridges()
            })
        },
        boundingBox() {
            if (this.map && this.isBBoxValid(this.boundingBox)) {
                this.fetchBridges()
            }
        },
        onlyRoads() {
           this.fetchBridges(true)
        },
        onlyGovt() {
            this.fetchBridges(true)
        }
    },

    mounted: function () {
        if (this.map && this.isBBoxValid(this.boundingBox)) {
            this.fetchBridges()
        }
    },
    beforeUnmount() {
        this.hideBridges()
    },

    methods: {
        fetchBridges(force = false) {
            if (this.map.getMapZoomLevel() < this.visibilityZoomLevel) {
                this.bbox = null
                this.hideBridges()
            } else if (force || (this.boundingBox && this.isBboxOutsideBbox(this.boundingBox, this.bbox))) {
                this.loading = true
                this.bridges = []
                const extendRate = 0.001
                this.bbox = [
                    this.boundingBox[0] - extendRate,
                    this.boundingBox[1] - extendRate,
                    this.boundingBox[2] + extendRate,
                    this.boundingBox[3] + extendRate
                ]
                let params = {
                    bbox: this.bbox,
                    only_govt: this.onlyGovt ? 1 : null,
                    only_roads: this.onlyRoads ? 1 : null,
                }
                this.restFetchParams(this.bridgeUrl, params, this.handleResponse, this.handleError)
            }
        },

        handleResponse: function (response) {
            this.loading = false
            this.hideBridges()
            if (response && response.data) {
                this.bridges = response.data
                this.drawBridges()
            }
        },

        handleError: function () {
            this.loading = false
            this.initView()
        },

        drawBridges: function () {
            this.bridges.forEach(function (bridge) {
                this.drawBridge(bridge, false)
            }, this)
        },

        drawBridge: function (bridge) {
            let markerStore = this.map.getMarkerStore()
            const icon = markerStore.getSvgMarker(bridgeSvg, null, null, '2.7em', '2.7em');
            this.map.showMapMarker(bridge.id, this.BRIDGE, bridge.lat,
                bridge.lon, icon, false, this.Z_INDEX.INFRONT)
        },

        hideBridges: function () {
            if (this.map) {
                this.map.removeMapItemsByType(this.BRIDGE)
            }
            this.bridges = []
            this.item = null
        },

        editBridge(id) {
            this.item = this.bridges.find(item => item.id === id)
        },

        startInspection() {
            this.$emit('startInspection', this.item)
        }

    }
}
</script>
